export const SKILLS = [
    {
        category: 'Languages', items: [
            { name: 'Java', icon: 'fa-brands fa-java', color: '#f89820' },
            { name: 'JavaScript', icon: 'fa-brands fa-js', color: '#f7df1e' },
            { name: 'Go', icon: 'fa-brands fa-golang', color: '#00add8' },
            { name: 'Python', icon: 'fa-brands fa-python', color: '#3776ab' },
        ]
    },
    {
        category: 'Frontend', items: [
            { name: 'React', icon: 'fa-brands fa-react', color: '#61dafb' },
            { name: 'React Native', icon: 'fa-brands fa-react', color: '#61dafb' },
            { name: 'Bootstrap', icon: 'fa-brands fa-bootstrap', color: '#7952b3' },
            { name: 'Tailwind', icon: 'fa-solid fa-wind', color: '#06b6d4' },
        ]
    },
    {
        category: 'Mobile & Desktop', items: [
            { name: 'Android', icon: 'fa-brands fa-android', color: '#3ddc84' },
            { name: 'Electron', icon: 'fa-solid fa-desktop', color: '#9feaf9' },
        ]
    },
    {
        category: 'Backend', items: [
            { name: 'Spring', icon: 'fa-solid fa-leaf', color: '#6db33f' },
            { name: 'Node.js', icon: 'fa-brands fa-node-js', color: '#339933' },
            { name: 'Express', icon: 'fa-brands fa-node', color: '#339933' },
        ]
    },
    {
        category: 'Databases', items: [
            { name: 'MySQL', icon: 'fa-solid fa-database', color: '#4479a1' },
            { name: 'MongoDB', icon: 'fa-brands fa-envira', color: '#47a248' },
            { name: 'Firebase', icon: 'fa-solid fa-fire', color: '#ffca28' },
            { name: 'Supabase', icon: 'fa-solid fa-bolt', color: '#3ecf8e' },
        ]
    },
    {
        category: 'DevOps & Tools', items: [
            { name: 'Docker', icon: 'fa-brands fa-docker', color: '#2496ed' },
            { name: 'Git', icon: 'fa-brands fa-git-alt', color: '#f05032' },
        ]
    },
];

export const PROJECTS = [
    {
        title: 'YourSQL',
        desc: 'A MySQL database console build with ElectronJS.',
        tags: ['ElectronJS', 'Bootstrap', 'NodeJS', 'MySQL'],
        icon: 'fa-solid fa-database',
        gradient: 'grad-3',
        github: 'https://github.com/rameshalagumalai/yoursql-app',
        live: 'https://rameshalagumalai.github.io/yoursql/',
    },
    {
        title: 'Crebit',
        desc: 'An Android app for personal finance tracking from expenses to incomes, built end-to-end with Antigravity.',
        tags: ['Android', 'Kotlin','Antigravity', 'Mobile', 'Finance'],
        icon: 'fa-solid fa-wallet',
        gradient: 'grad-6',
        github: 'https://github.com/rameshalagumalai/crebit',
        live: 'https://rameshalagumalai.github.io/crebit-web-site/',
    },
    {
        title: 'REST API Framework',
        desc: 'A configurable REST framework to create APIs easily, so that you can focus only on the business logic.',
        tags: ['Go', 'REST API'],
        icon: 'fa-solid fa-globe',
        gradient: 'grad-4',
        github: 'https://github.com/rameshalagumalai/go-rest-api-framework',
        live: '',
    },
    {
        title: 'PAM (Frontend)',
        desc: 'Frontend of PAM (Personal Accounts Manager), a personal expense and income tracking app.',
        tags: ['ReactJS', 'Bootstrap', 'PWA', 'Mobile first'],
        icon: 'fa-solid fa-money-bill',
        gradient: 'grad-2',
        github: 'https://github.com/rameshalagumalai/pam',
        live: 'https://pamapp.vercel.app/',
    },
    {
        title: 'Heim (Frontend)',
        desc: 'Frontend of Heim, a messaging based social media app.',
        tags: ['ReactJS', 'Bootstrap', 'PWA', 'Mobile first'],
        icon: 'fa-solid fa-message',
        gradient: 'grad-5',
        github: 'https://github.com/rameshalagumalai/heim-m2',
        live: 'https://heim.vercel.app/',
    },
    {
        title: 'TeamToDo (Frontend)',
        desc: 'Frontend of TeamToDo, a team projects and task management app.',
        tags: ['ReactJS', 'Bootstrap', 'Desktop first'],
        icon: 'fa-solid fa-users',
        gradient: 'grad-1',
        github: 'https://github.com/rameshalagumalai/team-to-do',
        live: 'https://teamtodoapp.vercel.app/',
    },
];

export const YOUTUBE_VIDEOS = [
    { title: 'Containerizing Micro-services using Docker and Minikube', link: 'https://youtu.be/GHcsAtUhw1c?si=ATop8FD1p4irGL4v' },
    { title: 'Docker Installation & Setup With WSL 2', link: 'https://youtu.be/kRTn8bZhu0Y?si=J-Rah_zf2uy7lN83' },
    { title: 'Navigation from one activity to another activity - Android Studio (Java)', link: 'https://youtu.be/BksTeivfAMM?si=a3lUyQ_9-uYtFd0G' },
    { title: 'C# - Introduction & Visual Studio Installation', link: 'https://youtu.be/6EFhSWiuNcc?si=56e-n2i1RO8gmTdR' },
];

export const ROAD_TRIPS = [
    { title: 'Kanyakumari', detail: '500 km · 2 days', imageLink: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/hness/kanyakumari-trip.webp', locationLink: 'https://maps.app.goo.gl/iTa5AezxG7EFAdTq9' },
    { title: 'Munnar', detail: '320 km · 2 days', imageLink: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/hness/munnar-trip.webp', locationLink: 'https://maps.app.goo.gl/rjeNBG6b7EDJLRmx8' },
    { title: 'Kolli Hills', detail: '550 km · 2 days', imageLink: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/hness/kolli-hills-trip.webp', locationLink: 'https://maps.app.goo.gl/4cWfyjYxK38apQQZ8' },
    { title: 'Dhanushkodi', detail: '405 km · 2 days', imageLink: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/hness/dhanushkodi-trip.webp', locationLink: 'https://maps.app.goo.gl/ezC7FQaGa42iwgu3A' },
];

export const DRAWINGS = [
    { title: 'Taj Mahal', medium: 'Pen', link: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/drawings/taj-mahal.webp' },
    { title: 'The Gateway of India', medium: 'Pen', link: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/drawings/the-gateway-of-india.webp' },
    { title: 'Albert Victor Bridge', medium: 'Pen', link: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/drawings/albert-victor-bridge.webp' },
    { title: 'Hawa Mahal', medium: 'Pen', link: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/drawings/hawa-mahal.webp' },
    { title: 'Adiyogi', medium: 'Pen', link: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/drawings/adiyogi.webp' },
    { title: 'Master', medium: 'Pen', link: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/drawings/master.webp' },
    { title: 'Buddha', medium: 'Pencil', link: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/drawings/buddha.webp' },
    { title: 'Safdarjung Tomb', medium: 'Pen', link: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/drawings/safdarjung-tomb.webp' },
    { title: 'Valluvar Kottam', medium: 'Pencil', link: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/drawings/valluvar-kottam.webp' },
    { title: 'Chennai Central', medium: 'Pencil', link: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/drawings/chennai-central.webp' },
    { title: 'Mysore Palace', medium: 'Pen', link: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/drawings/mysore-palace.webp' },
];

export const PHOTOS = [
    { title: 'Valluvar Kottam', location: 'Chennai', camera: 'iPhone SE 2', span: 'row-span-2', imageLink: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/photography/valluvar-kottam.webp', locationLink: 'https://maps.app.goo.gl/nG8HtmD6iCgTDEy5A' },
    { title: 'Mannavanur Farm', location: 'Kodaikanal', camera: 'iPhone SE 2', span: '', imageLink: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/photography/mannavanur-farm.webp', locationLink: 'https://maps.app.goo.gl/rVfXaDG9qEus2Pnn7' },
    { title: 'The Gateway of India', location: 'Mumbai', camera: 'Samsung Galaxy S23', span: '', imageLink: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/photography/the-gateway-of-india.webp', locationLink: 'https://maps.app.goo.gl/jsC8Utp4vaRoBrhp7' },
    { title: 'South Indian Fabric Art', location: 'Karaikudi', camera: 'Samsung Galaxy S23', span: 'row-span-2', imageLink: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/photography/karaikudi-fabric-art.webp', locationLink: 'https://maps.app.goo.gl/xLbEUj5cAe729ayg8' },
    { title: 'Teppakulam', location: 'Madurai', camera: 'Samsung Galaxy S23', span: '', imageLink: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/photography/madurai-teppakulam.webp', locationLink: 'https://maps.app.goo.gl/w724KEPvAwKwHcof8' },
    { title: 'Moon-lit Woods', location: 'Kodaikanal', camera: 'iPhone SE 2', span: 'row-span-2', imageLink: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/photography/moon-lit-woods.webp', locationLink: 'https://maps.app.goo.gl/6JprvjxcdLoM1qmC8' },
    { title: 'Thiruvalluvar Rock', location: 'Kanyakumari', camera: 'Samsung Galaxy S23', span: '', imageLink: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/photography/thiruvalluvar-rock.webp', locationLink: 'https://maps.app.goo.gl/yMJPHzowDhYS83Sf9' },
    { title: 'Upper Lake View', location: 'Kodaikaknal', camera: 'Samsung Galaxy S23', span: '', imageLink: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/photography/upper-lake-view.webp', locationLink: 'https://maps.app.goo.gl/XCYCgGryZBBB6AdN7' },
    { title: 'Split Sky', location: 'Madurai', camera: 'Samsung Galaxy S23', span: 'row-span-2', imageLink: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/photography/split-sky.webp', locationLink: 'https://maps.app.goo.gl/iVmRhhi6fexGi8bt6' },
    { title: 'The Range', location: 'Kudremukh', camera: 'Samsung Galaxy S23', span: '', imageLink: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/photography/kudremukh.webp', locationLink: 'https://maps.app.goo.gl/yWQ55kGRVy6o3Xdh8' },
    { title: 'Cargo Ship', location: 'Chennai', camera: 'Samsung Galaxy S23', span: '', imageLink: 'https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/photography/cargo-ship-aerial-view.webp', locationLink: 'https://maps.app.goo.gl/gejBz9Uju6tzQxBN6' },
];

export const SOCIAL_LINKS = [
    { icon: 'fa-brands fa-github', label: 'GitHub', href: 'https://github.com/rameshalagumalai', cls: 'social-github' },
    { icon: 'fa-brands fa-linkedin-in', label: 'LinkedIn', href: 'https://www.linkedin.com/in/ramesh-alagumalai-1762aa216/', cls: 'social-linkedin' },
    { icon: 'fa-brands fa-x-twitter', label: 'Twitter / X', href: 'https://x.com/ramesalagumalai', cls: 'social-twitter' },
    { icon: 'fa-brands fa-youtube', label: 'YouTube', href: 'https://www.youtube.com/@flagview2182', cls: 'social-youtube' },
    { icon: 'fa-brands fa-instagram', label: 'Instagram', href: 'https://www.instagram.com/_ramesh.___/', cls: 'social-instagram' },
    // { icon: 'fa-solid fa-envelope', label: 'Email', href: 'mailto:rameshalagumalai23@gmail.com', cls: 'social-email' },
];

export const NAV_ITEMS = [
    { id: 'about', label: 'About' },
    { id: 'skills', label: 'Skills' },
    { id: 'projects', label: 'Projects' },
    { id: 'blog', label: 'Blog' },
    { id: 'youtube', label: 'YouTube' },
    { id: 'rides', label: 'Rides' },
    { id: 'art', label: 'Art' },
    { id: 'photography', label: 'Photos' },
    { id: 'contact', label: 'Contact' },
];